import { BaseApiRouteService } from "mrb/core";

class CouponApiRouteService extends BaseApiRouteService {
    constructor() {
        super("coupons");
    }

    validatePromoCode() {
        return super.create(`${this.base}/promo-code/validate`);
    }

    validateSignupPromoCode() {
        return super.create(`${this.base}/promo-code/validate-signup`);
    }
}

export default CouponApiRouteService;
